import { Button, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import AngajatiCandidati from './AngajatiCandidati';
import ListaAngajati from './ListaAngajati';
import ListaCandidati from './ListaCandidati';


export default class Candidati extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            afiseazaCandidati: false,
            departament: -1,
            departamente: [],
            angajati: [],
            alertView: false
        }
    }

    componentDidMount() {
        this.access()
        this.getData()
    }


    ws = new Ws()
    u = new Utils()
    ls = new LocalStorage().GetUserData()


    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    getData = async (depart = null) => {
        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
        on a.id = ad.id_angajat where 1 = 1 and isnull(a.inactiv,0) != 2`, {
            p1: 'Candidat'
        })

        let _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
            p1: 1
        })



        let [angajati, departamente] = await Promise.all([_angajati, _departamente])
        console.log('angajati :>> ', angajati);
        console.log('departamente :>> ', departamente);

        if (angajati.Succes && departamente.Succes) {

            let ang = [...angajati.Content]
            let dep = [...departamente.Content]

            for (let i = 0, n = ang.length; i < n; i++) {
                let idxDep = dep.findIndex(d => Number(d.id) === Number(ang[i].id_departament))



                if (idxDep !== -1) {

                    ang[i]['nume_departament'] = dep[idxDep].nume
                }
            }

            console.log('ang :>> ', ang);

            console.log('dep :>> ', dep);

            if (depart) {
                ang = ang.filter(aa => Number(aa.id_departament) === Number(depart))
            }

            this.setState({
                angajati: ang,
                departamente: dep
            })


        }




    }


    changeDepartament = async (ev) => {

        let val = ev.target.value
        this.setState({ departament: val }, async () => {

            if (Number(val) === -1) {
                this.getData()
            } else {
                this.getData(val)
            }

        })
    }


    adaugaCandidatNou = async () => {

        let adaugaCandidat = await this.ws.insert('angajati', { nume: '', statusul: 'Candidat', id_categorie: 1, data_interviu:this.u.updateSqlNow() })

        console.log('adaugaCandidat :>> ', adaugaCandidat);

        if (adaugaCandidat.Succes) {
            this.props.history.push(`/fisapersonalaangajat/${adaugaCandidat.Content[0].id}`)
        }

    }

    adaugaAngajatNou = async () => {

        let adaugaAngajat = await this.ws.insert('angajati', { nume: '', statusul: 'In Curs de Angajare', id_categorie: 1 })


        if (adaugaAngajat.Succes) {
            this.props.history.push(`/fisapersonalaangajat/${adaugaAngajat.Content[0].id}`)
        }

    }



    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />
                <Grid style={{ maxWidth: 1300, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.pontaje.resurseUmane} </h1>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>



                        <ListaCandidati
                            title={this.dictionary.pontaje.operatiuniCandidati}
                            departament={this.state.departament}
                            departamente={this.state.departamente}
                            angajati={this.state.angajati.filter(aa => aa.statusul === 'Candidat' && aa.inactiv !== 1)}
                            changeDepartament={this.changeDepartament}
                            history={this.props.history}
                            getData={this.getData}
                        />






                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>



                        <ListaCandidati
                            title={this.dictionary.pontaje.angajatiDemisionati}
                            departament={this.state.departament}
                            departamente={this.state.departamente}
                            angajati={this.state.angajati.filter(aa => aa.statusul === 'Candidat' && aa.inactiv === 1)}
                            changeDepartament={this.changeDepartament}
                            history={this.props.history}
                            getData={this.getData}
                        />






                    </Grid>





                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>


                        <Button
                            style={{ marginRight: 20 }}

                            className={'add-button-blue'} onClick={this.adaugaCandidatNou}  >

                            <i style={{
                                fontSize: 14,
                                marginRight: 10
                            }} className='material-icons'>person_add</i>  {this.dictionary.pontaje.candidatNou}
                        </Button>

                        <Button
                            style={{ marginRight: 20 }}

                            className={'add-button-blue'} onClick={this.adaugaAngajatNou}  >

                            <i style={{
                                fontSize: 14,
                                marginRight: 10
                            }} className='material-icons'>person_add</i>  {this.dictionary.pontaje.angajareNoua}
                        </Button>
                    </Grid>





                </Grid>


                {/* <AngajatiCandidati/> */}
            </div >
        );
    }
}